let scrollEnabled = true;
let currentScroll = { x: 0, y: 0 };
function noscroll() {
  window.scrollTo(currentScroll.x, currentScroll.y);
}

export const disableScroll = () => {
  if (!scrollEnabled) {
    return;
  }
  currentScroll = {
    x: window.scrollX,
    y: window.scrollY,
  };
  window.addEventListener("scroll", noscroll);
  scrollEnabled = false;
};

export const enableScroll = () => {
  window.removeEventListener("scroll", noscroll);
  scrollEnabled = true;
};

export const isScrollEnabled = () => document.body.style.overflow === "hidden";

export const disableScrollOnTarget = (target) => {
  target.style.overflow = "hidden";
};

export const enableScrollOnTarget = (target) => {
  target.style.overflow = "";
};
